import { HttpClient } from '../HttpClient';

/**
 * Create user setting for an employee
 */
export const CreateUserSetting = async (employeeId, userSettingsInput) => {
  try {
    const { data } = await HttpClient.post(`api/usersettings/${employeeId}`, userSettingsInput);
    return data;
  } catch (err) {
    throw new Error(err.message || 'Failed to create user setting');
  }
};
